import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1653641591178'
        className='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='9827'
    >
        <path
            d='M512 32C249.6 32 32 249.6 32 512s217.6 480 480 480 480-217.6 480-480S774.4 32 512 32m64 147.2c38.4-6.4 70.4 19.2 70.4 57.6 6.4 44.8-25.6 83.2-70.4 89.6-38.4 6.4-64-19.2-70.4-64 0-38.4 32-76.8 70.4-83.2M467.2 844.8c-32 6.4-57.6-12.8-64-51.2-6.4-44.8 19.2-134.4 25.6-147.2l44.8-179.2c6.4-19.2 0-25.6-6.4-25.6-38.4 0-70.4 89.6-89.6 96-6.4 0-12.8-6.4-12.8-12.8 0-19.2 38.4-64 44.8-76.8 32-38.4 83.2-76.8 134.4-76.8 38.4-6.4 89.6 19.2 64 115.2l-44.8 198.4c-6.4 12.8-12.8 38.4-12.8 57.6 0 6.4 6.4 12.8 12.8 12.8 25.6 0 70.4-89.6 83.2-96 6.4 0 12.8 6.4 12.8 12.8 6.4 32-96 160-192 172.8'
            p-id='9828'
            fill='currentColor'
        ></path>
    </svg>
)

export const InformationIcon = props => <Icon component={SVG} {...props} />
